import { useMutation } from '@apollo/client';
import mutation from 'client/mutations/subscribeFF91';
import {SuccessResponse, SubscribeFf91Input} from 'generated-types/graphql';

interface SubscribeFF91Request {
  form: SubscribeFf91Input;
}

export default function useSubscribeFF91() {
  return useMutation<SuccessResponse, SubscribeFF91Request>(mutation);
}
